import { useContext, useEffect } from 'react';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/index';
import classNames from 'classnames';

import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import { ExternalPatientContext } from './constants';
import type { ModalType } from './types';

interface Props {
  message: string;
  mode?: 'light' | 'dark';
  showButtons?: boolean;
  source: ModalType | 'VISIT_SIDEBAR' | null;
  title: string;
}

export const ExternalError = ({
  message,
  mode = 'dark',
  showButtons = true,
  source,
  title,
}: Props) => {
  const externalPatientContext = useContext(ExternalPatientContext);
  const { trackEvent } = useTrackEvent();

  useEffect(() => {
    trackEvent(mixpanelEvents.externalError, {
      ...externalPatientContext,
      source,
      errorMessage: title,
    });
    // Disabling exhaustive deps so that event is only tracked once when error is displayed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={classNames('vai-p-6 vai-rounded-md', {
        'vai-bg-white': mode === 'dark',
        'vai-border vai-border-zinc-200': mode === 'light',
      })}
    >
      <FontAwesomeIcon
        className="vai-text-blaze-600"
        icon={faExclamationTriangle}
        size="2x"
      />
      <p className="vai-mt-4 vai-font-inter vai-font-semibold vai-text-lg vai-text-zinc-900">
        {title}
      </p>
      <p className="vai-mt-2 vai-font-inter vai-text-sm vai-text-zinc-500">
        {message}
      </p>
      {showButtons && (
        <Button
          className="vai-mt-4 vai-w-full"
          onClick={() => {
            trackEvent(mixpanelEvents.externalErrorRefreshClick, {
              ...externalPatientContext,
              source,
            });
            window.location.reload();
          }}
        >
          Refresh
        </Button>
      )}
    </div>
  );
};
